import { render, staticRenderFns } from "./bannerSwiper.vue?vue&type=template&id=0bcad3f0&"
import script from "./bannerSwiper.vue?vue&type=script&lang=js&"
export * from "./bannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./bannerSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/bannerSwiper.vue
// module id = null
// module chunks = 